// import { CardEvent } from "./cardEvent"
import { useEffect } from "react";


export const Events = ({ data }) => {
    // console.log(data);
    // const [showBitrixModal, setShowBitrixModal] = useState(false);

    useEffect(() => {
        const version = Date.now();
        const cssHref = "https://testevents.yes35.ru/events.css";
        const jsSrc = "https://testevents.yes35.ru/events.js";
        // const cssHref = "https://events.yes35.ru/events.css";
        // const jsSrc = "https://events.yes35.ru/events.js";

        // CSS виджета
        if (!document.querySelector(`link[href^="${cssHref}"]`)) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = `${cssHref}?v=${version}`;
            document.head.appendChild(link);
        }

        // JS виджета
        if (!document.querySelector(`script[src^="${jsSrc}"]`)) {
            const script = document.createElement("script");
            script.src = `${jsSrc}?v=${version}`;
            script.defer = true;
            document.body.appendChild(script);
        }

    }, []);

    // Функция для загрузки формы Bitrix24
//     const loadBitrixForm = () => {
//         const formContainer = document.getElementById('bitrix-form-container');
//         if (!formContainer) return;

//         formContainer.innerHTML = '';

//         const script = document.createElement('script');
//         script.dataset.b24Form = "inline/245/y3a2hc";
//         script.dataset.skipMoving = "true";
//         script.async = true;
//         script.innerHTML = `(function(w,d,u){
// var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
// var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
// })(window,document,'https://cdn-ru.bitrix24.ru/b8919455/crm/form/loader_245.js');`;

//         formContainer.appendChild(script);
//     };

    // Открытие модалки по параметру ?signup=true в URL
    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);
    //     if (params.get('signup') === 'true') {
    //         setShowBitrixModal(true);
    //     }
    // }, []);

    // useEffect(() => {
    //     if (showBitrixModal) {
    //         const timer = setTimeout(loadBitrixForm, 50);
    //         return () => clearTimeout(timer);
    //     }
    // }, [showBitrixModal]);

    // useEffect(() => {
    //     if (showBitrixModal) {
    //         document.body.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.overflow = '';
    //     }
    //     return () => {
    //         document.body.style.overflow = '';
    //     };
    // }, [showBitrixModal]);

    // const handleOpenForm = () => {
    //     setShowBitrixModal(true);
    // };

    return (
        <div id='events' className='text-center' style={{marginTop: 100}}>
            <div className='container'>
                <div className='section-title'>
                    <h2>Соревнования</h2>
                </div>
                {/* <div className='events'>
                    <img src="img/events_28122024.jpg" />
                    <button className="btn btn-custom btn-lg">
                        Онлайн регистрация завершена
                    </button>
                    <button onClick={handleOpenForm} className="btn btn-custom btn-lg">
                        Онлайн регистрация завершена
                    </button>
                </div> */}
                <div
                    id="iframe-events"
                    data-type="contests"
                ></div>
            </div>

            {/* {showBitrixModal && (
                <div 
                    className="bitrix-modal" 
                    onClick={() => setShowBitrixModal(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}
                >
                    <div 
                        className="bitrix-modal-content" 
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            padding: '30px',
                            position: 'relative',
                            maxWidth: '600px',
                            width: '90%',
                            maxHeight: '90vh',
                            overflow: 'auto'
                        }}
                    >
                        <button 
                            className="bitrix-modal-close" 
                            onClick={() => setShowBitrixModal(false)}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                lineHeight: 1
                            }}
                        >
                            &times;
                        </button>
                        <div id="bitrix-form-container"></div>
                    </div>
                </div>
            )} */}
        </div>
    )
}